import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../config/axios';
import { CreditCard, Loader2 } from 'lucide-react';

const Pricing = () => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    apiClient.get('/api/plans')
      .then((res) => {
        if (res.data?.success && res.data.plans) {
          setPlans(res.data.plans);
        }
      })
      .catch(() => setPlans([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex flex-col items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold text-gray-900">Plans and pricing</h1>
          <p className="mt-2 text-gray-600">Choose the plan that fits your needs</p>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-blue-600" />
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {plans.map((plan) => (
              <div
                key={plan.id}
                className="bg-white rounded-xl shadow-lg border border-gray-200 p-6"
              >
                <div className="flex items-center gap-2 mb-2">
                  <CreditCard className="w-5 h-5 text-blue-600" />
                  <h3 className="text-lg font-semibold text-gray-900">{plan.name}</h3>
                </div>
                {plan.description && (
                  <p className="text-sm text-gray-600 mb-2">{plan.description}</p>
                )}
                <div className="mt-2 space-y-1">
                  {plan.price_paise === 0 && (!plan.price_paise_monthly || plan.price_paise_monthly === 0) && (!plan.price_paise_yearly || plan.price_paise_yearly === 0) ? (
                    <p className="text-2xl font-bold text-gray-900">Free</p>
                  ) : (
                    <>
                      {(plan.price_paise_monthly ?? plan.price_paise) > 0 && (
                        <p className="text-2xl font-bold text-gray-900">
                          ₹{plan.price_inr_monthly}
                          <span className="text-sm font-normal text-gray-500">/month</span>
                        </p>
                      )}
                      {(plan.price_paise_yearly ?? 0) > 0 && (
                        <p className="text-lg font-semibold text-gray-800">
                          ₹{plan.price_inr_yearly}
                          <span className="text-sm font-normal text-gray-500">/year</span>
                        </p>
                      )}
                    </>
                  )}
                </div>
                <p className="text-sm text-gray-500 mt-2">{plan.max_workspaces} workspace(s)</p>
                {plan.max_contacts_per_workspace != null && (
                  <p className="text-xs text-gray-500">
                    Up to {plan.max_contacts_per_workspace.toLocaleString()} contacts per workspace
                    {plan.total_contacts_limit != null && plan.total_contacts_limit !== ''
                      ? ` · ${plan.total_contacts_limit.toLocaleString()} total on account`
                      : ''}
                  </p>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-8 space-y-2">
          <p className="text-sm text-gray-600">
            Sign in to manage your subscription
          </p>
          <Link
            to="/login"
            className="inline-block font-medium text-blue-600 hover:text-blue-500"
          >
            Sign in
          </Link>
          <span className="text-gray-400 mx-2">|</span>
          <Link
            to="/register"
            className="inline-block font-medium text-blue-600 hover:text-blue-500"
          >
            Create account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Pricing;
